import { isSignalDefinition } from "../event/private.js";
import type { AsyncNamespaceInput } from "../namespace/namespace.types.js";
import type { ProxyTarget, TargetStore } from "./store.types.js";
import { createProxy } from "../proxy/proxy.js";
import { configSync } from "../proxy/proxyConfig.js";
import * as symbols from "../utils/symbols.js";
import { assertNamespaceFree } from "../utils/utils.js";
import type { AnyFunction } from "../utils/utils.types.js";
import type { AssignOptions, Unset } from "../proxy/proxy.types.js";
import {
  assignMembers,
  cleanupStore,
  ensurePropStore,
  eventMembers,
  removeTargetProps,
  setupReady,
  setupTargetProps,
} from "./store.js";
import { assignSignal } from "../event/assign.js";
import { assignFunction } from "../function/assign.js";

/**
 *
 *
 *
 *
 *
 *
 */
export function unsetNamespace(
  store: TargetStore,
  target: ProxyTarget,
  unsetProps: Unset[],
): boolean {
  cleanupStore(store, target);
  setupReady(store);
  setupTargetProps(target, ...eventMembers, ...assignMembers);
  return unsetProps.map((d) => d()).every(Boolean);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function assignNamespace(
  store: TargetStore,
  target: ProxyTarget,
  ns: AsyncNamespaceInput<Record<string, unknown>>,
  options?: AssignOptions,
): Unset {
  assertNamespaceFree(store, "assign namespace to", options);
  cleanupStore(store, target, { ns: true });

  /*                                            */
  const unsetProps = Object.entries(ns).map(([key, val]) => {
    const [propStore, propTarget] = ensurePropStore(target, key);
    /*                                                               */
    return assignStoreValue(propStore, propTarget, val, options);
  });

  /*                                                    */
  store.isNs = true;
  removeTargetProps(target, ...eventMembers, ...assignMembers);
  store.onReady(createProxy(target, configSync));

  /*                    */
  return unsetNamespace.bind(undefined, store, target, unsetProps);
}

/**
 *
 *
 */
export function assignStoreValue(
  store: TargetStore,
  target: ProxyTarget,
  value: unknown,
  options?: AssignOptions,
): Unset {
  if (isSignalDefinition(value)) return assignSignal(store, target, value[symbols.event], options);

  if (typeof value === "function")
    return assignFunction(store, target, value as AnyFunction, options);

  if (value && typeof value === "object" && !Array.isArray(value) && value !== null) {
    return assignNamespace(
      store,
      target,
      value as AsyncNamespaceInput<Record<string, unknown>>,
      options,
    );
  }

  throw Error(
    `Unexpected Input for: ${
      store.path
    }. Nexus expects input to be either a function, nexus definition, or an object with at least one property, given was: ${typeof value}`,
  );
}
